import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    //id: AutoId, optional // Mã tự sinh
    isDisabled: false, //boolean, optional // Cho biết Công ty có bị disable hay không
    ten: { //required // Tên sở trường
        vi: null, //string, required // Tên tiếng Việt
        en: null, //string, optional // Tên tiếng Anh
    },
    hotline: null, //string, optional // Hotline
    email: null, //string, optional // Email
    dien_thoai: null, //string, optional // Số điện thoại
    website: null, //string, optional // Website
    slogan: null, //string, optional // Slogan
    avatar_id: null, //IdRef, optional // Mã ảnh đại diện
    dia_chi: { //optional // Địa chỉ
        province_id: null, //IdRef, optional // Mã tỉnh/TP
        province_name: null, //string, optional // Tên tỉnh/TP
        district_id: null, //IdRef, optional // Mã quận/huyện
        district_name: null, //string, optional // Tên quận/huyện
        dia_chi: null, //string, //required // Địa chỉ đầy đủ
    },
    giay_phep_kinh_doanh: { //optional // Giấy phép kinh doanh lữ hành
        so_giay_phep: null, //string, required // Số giấy phép
        noi_cap: null //string, optional // Nơi cấp
    },
    nguoi_quan_ly_ids: [], //array of IdRef, optional // Danh sách mã người quản lý công ty lữ hành 
    noi_dung_hien_thi:[  // optional Nội dung hiển thị
        {
            ngon_ngu: undefined, // required Ngôn ngữ hiển thị
            gioi_thieu: undefined, // required Giới thiệu thông tin
            anh_id: undefined, // optional Id của ảnh hiển thị
            noi_dung: undefined, // required Nội dung hiển thị
        }
    ],
    ngon_ngu: "vi",
    noiDungHienThiFilter: {
        gioi_thieu: undefined, 
        anh_id: undefined, 
        noi_dung: undefined, 
    },
};

// validation form
model.validForm = {

    //id: AutoId, optional // Mã tự sinh
    isDisabled: [], //boolean, optional // Cho biết Công ty có bị disable hay không
    ten: { //required // Tên sở trường
        vi: [ValidService.required], //string, required // Tên tiếng Việt
        en: [], //string, optional // Tên tiếng Anh
    },
    hotline: [], //string, optional // Hotline
    email: [ValidService.checkEmail], //string, optional // Email
    dien_thoai: [], //string, optional // Số điện thoại
    website: [], //string, optional // Website
    slogan: [], //string, optional // Slogan
    avatar_id: [], //IdRef, optional // Mã ảnh đại diện
    dia_chi: { //optional // Địa chỉ
        province_id: [], //IdRef, optional // Mã tỉnh/TP
        province_name: [], //string, optional // Tên tỉnh/TP
        district_id: [], //IdRef, optional // Mã quận/huyện
        district_name: [], //string, optional // Tên quận/huyện
        dia_chi: [ValidService.required], //string, //required // Địa chỉ đầy đủ
    },
    giay_phep_kinh_doanh: { //optional // Giấy phép kinh doanh lữ hành
        so_giay_phep: [ValidService.required], //string, required // Số giấy phép
        nơi_cap: [] //string, optional // Nơi cấp
    },
    nguoi_quan_ly_ids: [], //array of IdRef, optional // Danh sách mã người quản lý công ty lữ hành 

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.trangThai = [
    {
        code: "true",
        text: "Khóa"
    },
    {
        code: "false",
        text: "Mở khóa"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["ten.vi", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "ten.vi": "",
            "email": "",
            "dien_thoai": "",
            "website": ""
        },
        valid: {
            "ten.vi": [],
            "email": [],
            "dien_thoai": [],
            "website": [],
        },
        operator: {
            "ten.vi": ":regex_i:", //:regex:, $vn_text=Viêt nam
            "email": ":regex_i:",
            "dien_thoai": ":regex_i:",
            "website": ":regex_i:"
        }
    }
};

export default model;